<template>
    <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">Available Categories  </v-flex>
            <v-text-field
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>
            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-5" v-if="loads()[0] == null">
             
                Welcome {{ staff.gender == 'male' ? 'Mr.' : 'Miss.' }} {{staff.fullname.toUpperCase()}},
                 there are no stored movies yet
                <br><br>
                <h4>Simply add a new  movie by clicking on the <b>+</b> icon</h4>
            </v-flex>
            <v-flex xs12 sm12 md4 v-for="(item, index) in loads()"  :key="index">
                <v-card >
                  
                    <v-img :src="item.image"   height="300px"  @click="next(item.name)" title="view">
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text" ><b></b></span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-img>

                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0 "><b>{{item.name.toUpperCase()}}</b></h3>
                            <div>{{item.desc}}</div>
                            
                            <edit-category :name="item.name" :desc="item.desc" v-if="crc(staff.rights,'002')"></edit-category>
                            <delete-category :name="item.name" v-if="crc(staff.rights,'003')"></delete-category>
                        </div>
                    </v-card-title>
                </v-card>
              
            </v-flex>
     
            </v-layout>
<Add-category  v-if="crc(staff.rights,'001')"></Add-category>
    </v-container>
</template>

<script>
import AddCategory from '@/components/Category/AddCategory.vue'
import EditCategory from '@/components/Category/EditCategory.vue'
import DeleteCategory from '@/components/Category/DeleteCategory.vue'
import {checkright} from '@/validator'

/*

*/
export default {
    name: 'Category',
    components: {
      AddCategory,
      EditCategory,
      DeleteCategory,
    },
    data() {
        return {
            appTitle: 'Exodus',
            staff:this.$store.getters.getStaff,
            drawer: true,
            
                    };
    },methods:{
      
      //This method is used for assigning rights-based functionality
      crc(array,value){
      return checkright(array,value);
    },
        next(value){
             this.$router.push({ name:'movies', params:{category:value}});
        },
        loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateCategory',false);
            self.$store.dispatch('updateMovies',false);
            
            value = self.$store.getters.getCategory;
            return value;
           
            
        }
    }
};
</script>

<style scoped>
.fab-container{
    position:fixed;
    
    bottom:0;
    right:0
}
</style>